module.exports = __webpack_public_path__ + "static/media/web.858e74d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/web.png
// module id = 1196
// module chunks = 114